import { MEMBERSHIP_SEASON } from '../config/membershipSeason';
import { MEMBER_ACTIVE_SEASONS } from './memberStatus';

function mapLikeToObject(value) {
  if (!value) return {};
  if (value instanceof Map) return Object.fromEntries(value);
  if (typeof value === 'object') return { ...value };
  return {};
}

export function emptyMembershipCodes() {
  return { ecardCode: '', pnrCode: '' };
}

export function buildEmptyMembershipCodesBySeason() {
  const bySeason = {};
  for (const season of MEMBER_ACTIVE_SEASONS) {
    bySeason[season] = emptyMembershipCodes();
  }
  return bySeason;
}

export function getMembershipCodesForSeason(user, season = MEMBERSHIP_SEASON) {
  if (!user || !season) return emptyMembershipCodes();
  const bySeason = mapLikeToObject(user.membershipCodesBySeason);
  const seasonCodes = bySeason[season];
  if (seasonCodes && typeof seasonCodes === 'object') {
    return {
      ecardCode: seasonCodes.ecardCode != null ? String(seasonCodes.ecardCode).trim() : '',
      pnrCode: seasonCodes.pnrCode != null ? String(seasonCodes.pnrCode).trim() : '',
    };
  }
  return emptyMembershipCodes();
}

export function buildMembershipCodesBySeasonFromUser(user) {
  const bySeason = {};
  for (const season of MEMBER_ACTIVE_SEASONS) {
    bySeason[season] = getMembershipCodesForSeason(user, season);
  }
  return bySeason;
}
